module.exports = __webpack_public_path__ + "media/images/athletes/996-f85efa35c41e7029773f123a4a3af513.png";